import { CloudCommand } from "../types.js";

export const getSavedSearches: CloudCommand = {
    action: "SALES/GET_SAVED_SEARCHES",
    commandName: "sales.getSavedSearches",
    buildPayload: ({ start, count }) => ({ start, count }),
};
